import { isNullish } from "radashi";
import { isFlowValid } from "../../components/BatchSelectionDataTable/helpers/getColumnsValidation";
import { BatchSelectionRow } from "../types";

export type InitLoadingStateArgs = {
  correlationId: string;
  prevRow: BatchSelectionRow | undefined;
  row: BatchSelectionRow;
};

export function initLoadingState({
  correlationId,
  prevRow,
  row,
}: InitLoadingStateArgs): BatchSelectionRow {
  const inputsChanged = inputKeys.some(
    (key) => !isNullish(row[key]) && row[key] !== prevRow?.[key],
  );
  if (!inputsChanged) return row;

  const flowValid = isFlowValid(row.flow) === true && row.flow !== "";
  return {
    ...row,
    output: {
      correlationId,
      pipeResult: null,
      status: flowValid ? "loading" : "idle",
      subProductsSelection: null,
      suggestion: null,
    },
    status: flowValid ? row.status : null,
  };
}

const inputKeys: Array<keyof BatchSelectionRow> = ["dp", "flow", "pipeSize"];
